<div class="ml-10">
    <mat-form-field appearance="outline" color="accent" subscriptSizing="dynamic">
        <mat-label>{{ title }}</mat-label>
        <input #searchInput matInput
               autocomplete="off"
               type="text">
    </mat-form-field>
</div>
